import { render, staticRenderFns } from "./SimulationCompetenciesEdit.vue?vue&type=template&id=385629aa&scoped=true"
import script from "./SimulationCompetenciesEdit.vue?vue&type=script&lang=js"
export * from "./SimulationCompetenciesEdit.vue?vue&type=script&lang=js"
import style0 from "./SimulationCompetenciesEdit.vue?vue&type=style&index=0&id=385629aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385629aa",
  null
  
)

export default component.exports